export function getAll() {
  var items = [
    {
      value: 0,
      name: "KDSKitchen",
      text: "KDS廚房",
    },
    {
      value: 1,
      name: "KDSCheckFood",
      text: "KDS對菜",
    },
    {
      value: 2,
      name: "NDS",
      text: "NDS",
    },
  ];
  return items;
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
